<template>
    <section>
        <SideBar v-if="!OpenMode" />
        <TopBar v-if="!OpenMode" />
        <div :class="[!OpenMode ? 'content' : '' ]">    
        <div class="main-content-header">
            <h1>Posiciones de Unidades</h1>
        </div>
        <LoadingContent v-if="isLoading" />
        <div class="row">
            <div class="col-lg-12 col-md-6">
                <div class="card mb-30" :style="{height:[contentHeight+'px']}">
                    <div class="row " :class="[!OpenMode ? 'p-4' : '']">
                        <div class="content-header  col-12"> 
                            <div class="row">
                                <div class="col-6 text-start ps-4"></div>
                                <div class="col-6"><p class="p-1 pe-4 mb-0 text-end">Página {{ paginaActual }} de {{ totalPaginas }} </p></div>
                                
                                <div class="col-2 offset-10 ps-2 pe-5 text-end pb-0 pt-0">
                                    <ul class="list-unstyled mb-0 d-flex justify-content-between pager-btns float-right">
                                        <li><button @click="setPaginacion('first')" type="button" class="pager pager-first btn btn-sm btn-outline-secondary"><ChevronDoubleLeftIcon /></button></li>
                                        <li><button @click="setPaginacion('prev')"  type="button" class="pager pager-prev  btn btn-sm btn-outline-secondary"><ChevronLeftIcon /></button></li>
                                        <li><button @click="setPaginacion('next')"  type="button" class="pager pager-next  btn btn-sm btn-outline-secondary"><ChevronRightIcon /></button></li>
                                        <li><button @click="setPaginacion('last')"  type="button" class="pager pager-last  btn btn-sm btn-outline-secondary"><ChevronDoubleRightIcon /></button></li> 
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-10 col-12">
                            <div class="table-responsive ps-2">
                                <b-table-simple class="browse" hover small caption-top responsive >
                                    <b-thead head-variant="light"  class="table-header">
                                        <b-tr>
                                            <b-th>ID</b-th>
                                            <b-th class="text-start">Fecha Act.</b-th>
                                            <b-th class="text-start">Latitud</b-th>
                                            <b-th class="text-start">Longitud</b-th>
                                            <b-th class="text-start">Dirección</b-th>
                                            <b-th class="text-start">Velocidad</b-th>
                                            <b-th class="text-start">Estatus</b-th>
                                            <b-th class="text-start">Zona</b-th>
                                        </b-tr>
                                    </b-thead>
                                    <b-tbody>
                                        <b-tr v-for="geo in geodevices" 
                                            :key="geo.id" 
                                            @click="selectedRegistro = geo" 
                                            @dblclick=" (!OpenMode ? modificar() : exportRegistry()) " 
                                            :class="{ 'selected-row': (selectedRegistro.id == geo.id) }">
                                            <b-td class="text-center">{{ geo.id }}</b-td>
                                            <b-td class="text-nowrap">{{ geo.position_lat }}</b-td>
                                            <b-td class="text-nowrap">{{ geo.position_lng }}</b-td>
                                            <b-td class="text-nowrap">{{ formato(geo.fecha_act,'MMM-DD-YYYY') }}</b-td>
                                            <b-td class="text-nowrap">{{ geo.address }}</b-td>
                                            <b-td class="text-nowrap">{{ geo.speed }}</b-td>
                                            <b-td class="text-nowrap">{{ geo.statusgps }}</b-td>
                                            <b-td class="text-nowrap">{{ geo.zoneid }}</b-td>
                                        </b-tr>
                                    </b-tbody>
                                </b-table-simple>
                            </div>
                        </div> 
                        <div class="col-2 ps-2 pe-5" >
                            <ul class="d-block list-unstyled action-block">
                                <li v-if="!OpenMode"><button @click="showMapa = true" :disabled="disableBtn" class="btn btn-xs btn-info btn-block">Mapa</button></li>
                                <li v-if="OpenMode"><button @click="exportRegistry()" class="btn btn-xs btn-success btn-block">Elegir</button></li>
                            </ul>
                        </div>
                        
                        <div class="content-footer col-12 text-start"></div>
                    </div>
                </div>
            </div>
            <MapaComponent v-if="showMapa">
                <template v-slot:header>
                    <h6 class="text-uppercase">Mapa</h6>
                </template>
                <template v-slot:body >
                    <iframe :src="'https://maps.google.com/maps?q=' + selectedRegistro.position_lat + ',' + selectedRegistro.position_lng + '&t=&z=15&ie=UTF8&iwloc=&output=embed'"  width="500" height=”300″ 
                        frameborder="0" style="border:0" allowfullscreen=""  loading="lazy" referrerpolicy="no-referrer-when-downgrade">
                    </iframe>
                </template>
            </MapaComponent>
        </div>
        </div>
    </section>
</template>

<script>
import ChevronLeftIcon from 'vue-material-design-icons/ChevronLeft.vue';
import ChevronDoubleRightIcon from 'vue-material-design-icons/ChevronDoubleRight.vue';
import ChevronDoubleLeftIcon from 'vue-material-design-icons/ChevronDoubleLeft.vue';
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue';
import LoadingContent from '@/components/LoadingSpinner.vue'
import handleGlobals from '@/mixins/handleGlobals'
import handleBrowse from '@/mixins/handleBrowse'
import MapaComponent from '@/components/ModalComponent.vue';

import SideBar from '@/components/SideBarNav.vue';
import TopBar from '@/components/TopBarNav.vue';
export default {
    name:'WIN_gpsGeoZones',
    props:['mode','perpage'],
    mixins:[handleGlobals,handleBrowse],
    components:{SideBar,TopBar,MapaComponent,ChevronLeftIcon,ChevronDoubleRightIcon,ChevronDoubleLeftIcon,ChevronRightIcon, LoadingContent},
    data(){
        return{
            geodevices: [],
            showMapa: false
        }
    },
    created(){
        if(this.OpenMode == false){
            this.getFiltros()
        } 
    },
    methods:{
        async getFiltros(){
                await fetch(this.$api+'/rdx', {    
                    method: "POST",
                    headers: {
                        'Content-Type' : 'application/json',
                        'Authorization' : this.$store.state.iasctratkn
                    },
                    body: JSON.stringify({accion: "filters"})
                }).then((response)=>{
                    if(response.ok){
                        return response.json()
                    }
                }).then((data)=>{
                    let reg = data['DEV']
                    if(reg){
                        this.paginaActual       = reg['paginaActual'].dato
                        if(this.paginaActual == '') this.paginaActual = 0
                    }else{
                        this.paginaActual       = 1
                    }
                }).catch((err)=>{
                this.falseToken(err)
            });
        },
        consultar(){
            this.isLoading = true
            
            fetch(this.$api+'/rdx', {
                method: "POST",
                headers: { "Content-Type": "application/json",
                            'Authorization' : this.$store.state.iasctratkn },
                body: JSON.stringify({  accion: "browse", 
                                        archivo: "gpsDevices", 
                                        activarPaginas:true,
                                        orden: "id",
                                        filtro: {paginaActual: {dato: 'NA'}},
                                        pagina: this.paginaActual, 
                                        paginacion: this.paginacion,
                                        registrosxpagina: this.rows })
            }).then((response)=>{
                if(response.ok){
                    return response.json();
                }   
            }).then((data)=>{
                this.geodevices     = data['registros'];
                this.totalRegistros = data['totalRegistros'];
                this.totalPaginas   = data['totalPaginas'];
                this.paginaActual   = data['paginaActual'];
            }).finally(()=>{
                this.isLoading = false;
            }).catch((err)=>{
                this.falseToken(err)
            });
        },
        
    }
}
</script>

